/**
 * 화면 구현
 */
import SbsPlayerLogger from '../../utils/logger';
import { FullScreen } from '../../common';
import { SbsPlayerGlobal } from '../../common/global';

customElements.define(
  'sbs-player-dialog-live-preview-end',
  class extends HTMLElement {
    constructor() {
      super();
      this.visible = false;
    }

    set visible(value) {
      this._visible = value;
      this.render();
    }

    get visible() {
      return this._visible;
    }

    static get observedAttributes() {
      return ['title', 'html'];
    }

    async attributeChangedCallback(name, oldValue, newValue) {
      try {
        if (name === 'title' && oldValue !== newValue) {
          this.title = newValue;
        }
        if (name === 'html' && oldValue !== newValue) {
          this.html = newValue;
        }
      } catch (error) {
        console.log(error);
      }
    }

    async connectedCallback() {
      try {
        this.render();
      } catch (error) {
        console.log(error);
      }
    }

    disconnectedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    adoptedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    render() {
      try {
        const { info } = SbsPlayerGlobal.state.data;
        const imageUrl =
          info.defaultimage ||
          info.thumbimg ||
          info.thumbs['640'] ||
          info.program_image;
        this.innerHTML = `<img src="${imageUrl}" style="width: 100%;
            height: 100%;
            object-fit: contain;
            position: absolute;
            top: 0;
            left: 0;
            display: ${imageUrl ? 'block' : 'none'};
          " />
        <div class="playerDialogLivePc_w current" role="dialog">
          <div class="playerDialogContents">
            <div class="playerDialogTop">
              <p class="playerDialogTop-text">3분 미리보기가 종료되었습니다.
                <strong class="txt01">로그인 후 무료로 라이브를 시청하세요.</strong>
              </p>
            </div>
            <div class="playerLiveBtns_w">
              <a href="javascript:void(0);" class="btn_bgGreen">로그인</a>
              <a href="javascript:void(0);" class="btn_bgGreen">회원가입</a>
            </div>
          </div>
        <sbs-player-fullscreen></sbs-player-fullscreen>
      </div>`;

        this.styles();
        this.event();
      } catch (error) {
        console.log(error);
      }
    }

    styles() {
      try {
        if (SbsPlayerGlobal.state.is_mobile) this.style.paddingTop = `56.2%`;
      } catch (error) {
        console.log(error);
      }
    }

    event() {
      try {
        this.fullscreen = new FullScreen(this);

        const SIGNUP_URL =
          window.location.hostname.indexOf('.golf.') > -1
            ? `https://web.golf.developers.sbs.co.kr/member/signup?returnUrl=${encodeURIComponent(
                location.href
              )}`
            : `https://join.sbs.co.kr/login/login.do?div=pc_login&returnUrl=${encodeURIComponent(
                location.href
              )}`;
        const LOGIN_URL =
          window.location.hostname.indexOf('.golf.') > -1
            ? `https://web.golf.developers.sbs.co.kr/member/login?returnUrl=${encodeURIComponent(
                location.href
              )}`
            : `https://join.sbs.co.kr/login/login.do?div=pc_login&returnUrl=${encodeURIComponent(
                location.href
              )}`;

        this.querySelectorAll('a').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            const buttonText = button.textContent.trim();
            const targetURL = (buttonText.includes('회원가입') || buttonText.includes('가입'))
              ? SIGNUP_URL : LOGIN_URL;
            
            // 모바일 앱 웹뷰 대응
            if (window.webkit && window.webkit.messageHandlers) {
              // iOS WKWebView
              window.webkit.messageHandlers.openURL?.postMessage(targetURL);
            } else if (window.Android && window.Android.openURL) {
              // Android WebView
              window.Android.openURL(targetURL);
            } else {
              // 일반 웹브라우저
              window.open(targetURL, '_blank');
            }
          });
        });

        const fullscreenElement = this.querySelector('sbs-player-fullscreen');
        fullscreenElement.addEventListener(
          'button-toggle-fullscreen',
          (event) => {
            this.fullscreen.toggle();
          }
        );
      } catch (error) {
        console.log(error);
      }
    }
  }
);
